import React from 'react';
import CaAccountFormView from "./CaAccountFormView";

const CaAccountModalView = props => {

    const {
        title,
        body,
        iconsBasePath,
        onClose,
        topNavText,
        onTopNavClick,
        topNavCta,
        subNavText,
        onSubNavClick,
        subNavCta,
        validationMutation,
        selectData,
        formFieldsData,
        checkboxData,
        actions
    } = props;

    //TODO: MOVE...
    const data0 = formFieldsData?formFieldsData.map(item=>item.id):[];
    validationMutation.map((item)=>{
        if ( selectData && item.id == selectData.id ) {
            selectData.value=item.value;
            selectData.valid=item.valid;
            selectData.validateItem=item.validateItem;
            return;
        }
        if ( checkboxData && item.id == checkboxData.id ) {
            checkboxData.value=item.value;
            checkboxData.valid=item.valid;
            checkboxData.validateItem=item.validateItem;
            return;
        }
        if ( formFieldsData ) {
            formFieldsData[data0.indexOf(item.id)].value=item.value;
            formFieldsData[data0.indexOf(item.id)].valid=item.valid;
            formFieldsData[data0.indexOf(item.id)].validateItem=item.validateItem;
        }
    });

    return (
        
        <div className={"AccountModal__inner"}>
            <div className="AccountModal__closeWrapper">
                <a className="AccountModal__close"
                   onClick={()=>onClose()}>
                    <img src={iconsBasePath+"icon__close--black.svg"} />
                </a>
            </div>
            <div className={"AccountModal__content"}>
                {!!title && <h2>{title}</h2>}
                {!!body && <p>{body}</p>}
                {!!topNavText && <div className={"AccountModal__p"}>{topNavText} <a href={"#"} onClick={()=>onTopNavClick()}>{topNavCta}</a></div>}
                <CaAccountFormView {...props} />
            </div>

            {actions &&
            <div className={"AccountModal__actions"}>
                <div className={"AccountModal__hr"}></div>
                {actions.map((item,i)=><div className={"AccountModal__p"} key={i}><a href={"#"} onClick={item.onClick}>{item.label}</a></div>)}
            </div>}

            {subNavText &&
            <div>
                <div className={"AccountModal__hr"}></div>
                <div className={"AccountModal__p"}>{subNavText} <a href={"#"} onClick={()=>onSubNavClick()}>{subNavCta}</a></div>
            </div>}
        </div>
    )
}

export default CaAccountModalView;